import { jsx as _jsx } from "react/jsx-runtime";
import ErrorDisplay from "./ErrorDisplay";
var Error404 = function () {
    return _jsx(ErrorDisplay, { code: "404", message: "error.404.message" });
};
export default Error404;
